import { APP_LOCAL_DATE_FORMAT } from "@/config/constants";
import { IEdoChapter } from "@/shared/model/edo-chapter.model";
import {
  Avatar,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@/components/ui";
import { Bookmark, Eye, Pencil, Trash2 } from "lucide-react";
import "moment/locale/it";
import { TextFormat } from "react-jhipster";

interface ChapterRowProps {
  chapter?: IEdoChapter;
  viewChapter: (chapter: IEdoChapter) => void;
  editChapter: ((chapter: IEdoChapter) => void) | null;
  deleteChapter: ((chapter: IEdoChapter) => void) | null;
  nested: boolean;
}

export const ChapterRow = (props: ChapterRowProps) => {
  const { chapter, viewChapter, editChapter, deleteChapter, nested } = props;
  if (!chapter) return null;

  return (
    <ListItem
      className={`flex items-center gap-3 py-2.5 transition-colors hover:bg-primary/5 ${nested ? "pl-8 sm:pl-10 pr-4" : "px-5"}`}
    >
      <ListItemIcon className="shrink-0">
        <Avatar className="h-8 w-8 bg-primary/10">
          <Bookmark className="h-3.5 w-3.5 text-primary" />
        </Avatar>
      </ListItemIcon>
      <ListItemText
        primary={
          <span className="text-sm font-medium text-[var(--color-mockup-text)]">
            {chapter.title}
          </span>
        }
        secondary={
          <span className="text-xs text-[var(--color-mockup-text-light)]">
            <TextFormat
              value={chapter.createdAt}
              type="date"
              format={APP_LOCAL_DATE_FORMAT}
            />
          </span>
        }
        className="min-w-0 flex-1"
      />
      <ListItemSecondaryAction className="ml-2 flex shrink-0 items-center gap-0.5">
        <IconButton
          onClick={() => viewChapter(chapter)}
          aria-label="Visualizza capitolo"
          className="w-7 h-7 rounded-full text-[var(--color-mockup-text-light)] hover:text-primary hover:bg-primary/10"
        >
          <Eye className="h-3.5 w-3.5" />
        </IconButton>
        {editChapter != null && (
          <IconButton
            onClick={() => editChapter(chapter)}
            aria-label="Modifica capitolo"
            className="w-7 h-7 rounded-full text-[var(--color-mockup-text-light)] hover:text-primary hover:bg-primary/10"
          >
            <Pencil className="h-3.5 w-3.5" />
          </IconButton>
        )}
        {deleteChapter != null && (
          <IconButton
            onClick={() => deleteChapter(chapter)}
            aria-label="Elimina capitolo"
            className="w-7 h-7 rounded-full text-[var(--color-mockup-coral)] hover:bg-[var(--color-mockup-coral)]/10"
          >
            <Trash2 className="h-3.5 w-3.5" />
          </IconButton>
        )}
      </ListItemSecondaryAction>
    </ListItem>
  );
};
